import React from "react";
import styles from "./Toggle.module.css";

interface ToggleProps {
    checked: boolean;
    onChange?: (checked: boolean, event?: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    label?: string;
    style?: React.CSSProperties;
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, disabled = false, label, style }) => {
    return (
        <div className={styles.toggleContainer} style={style}>
            {label && <span className={styles.label}>{label}</span>}
            <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        // e.preventDefault();
                        e.stopPropagation();
                        onChange?.(!checked, e)
                    }}
                    disabled={disabled}
                />
                <span className={`${styles.slider} ${disabled ? styles.disabled : ""}`}></span>
            </label>
        </div>
    );
};

export default Toggle;
